import { useNavigate } from 'react-router-dom'
import useTrackingLoader from '../hooks/useTrackingLoader'
import { TrackingProvider } from '../TrackingContext'
import Info from './Info'
import { Logo } from './Logo'
import { Box, Spinner } from '@grupoboticario/flora-react'
import { useEffect } from 'react'

const Tracking = () => {
  const { data: tracking, loaded, error } = useTrackingLoader()

  const navigate = useNavigate()

  useEffect(() => {
    if (!loaded || tracking) return

    const locale = error?.response?.data?.locale
    navigate('/expirado', { state: { locale: typeof locale === 'string' ? locale : undefined } })
  }, [loaded, tracking, error, navigate])

  return tracking ? (
    <TrackingProvider data={tracking}>
      <Logo />
      <Info />
    </TrackingProvider>
  ) : (
    <Box css={{ margin: '35vh auto' }}>
      <Spinner label="Loading, please wait." size="md" />
    </Box>
  )
}

export default Tracking
